import { z } from 'zod'
import { REQUIRED_MESSAGE } from '@Const/error-messages'
import { stringSizeMaxMessage } from '@Entities/schemas/work/error-messages'
import { IPIValidator } from '@App/helpers/validate'
import { FormFields } from '@App/forms/v2/common/form-field'
import { FormFieldTypes } from '@App/enum/form-field-types'
import React from 'react'
import populateSchema from '@App/forms/v2/helpers/populate-schema'
import SongwriterNameTooltip from '@Scenes/SongwriterRegistrationScene/Tooltips/SongwriterNameTooltip'
import IpiTooltip from '@Scenes/SongwriterRegistrationScene/Tooltips/IpiTooltip'

const createSongwriterFormSchema = z.object({
    name: z.string().min(1, REQUIRED_MESSAGE).max(200, stringSizeMaxMessage('Name', 200)),
    ipiNumber: z
        .string()
        .max(11, stringSizeMaxMessage('IPI Number', 11))
        .refine((ipi) => IPIValidator(ipi, false), 'Invalid IPI Number')
        .optional(),
    termsAndConditions: z
        .boolean({
            error: REQUIRED_MESSAGE,
        })
        .refine((val) => val, {
            message: REQUIRED_MESSAGE,
        }),
})

type CreateSongwriterType = z.infer<typeof createSongwriterFormSchema>

const createSongwriterFormFieldsNoSchema: FormFields<CreateSongwriterType> = {
    name: {
        name: 'name',
        label: 'Songwriter name',
        type: FormFieldTypes.TEXT,
        inputHeader: (
            <h5>
                Songwriter Name
                <SongwriterNameTooltip />
            </h5>
        ),
    },
    ipiNumber: {
        name: 'ipiNumber',
        label: 'Writer IPI',
        type: FormFieldTypes.TEXT,
        tooltip: <IpiTooltip />,
    },
    termsAndConditions: {
        name: 'termsAndConditions',
        label: 'Accept ',
        type: FormFieldTypes.CHECKBOX,
        className: 'terms-and-conditions',
    },
}

const createSongwriterFormFields: FormFields<CreateSongwriterType> = populateSchema(
    createSongwriterFormFieldsNoSchema,
    createSongwriterFormSchema
)

export { createSongwriterFormSchema, CreateSongwriterType, createSongwriterFormFields }
